import { memo, RefObject, useRef, useState } from "react";
import styles from "./Player.module.scss";
import musicImg from "../../assets/images/vinil-snow.png";
import snowAudio from "../../assets/audio/let-it-snow-sinatra.mp3";
import { CURSOR_ENUM } from "../Cursor";
import { FAVICON_ENUM } from "../Favicon/Favicon";

interface PlayerProps {
  setCursor: (cursor: CURSOR_ENUM) => void;
  setFavicon: (favicon: FAVICON_ENUM) => void;
}

function Player({ setCursor, setFavicon }: PlayerProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const audioRef: RefObject<HTMLAudioElement> = useRef(null);

  function play() {
    if (audioRef?.current) {
      audioRef.current.play();
    }
  }

  function pause() {
    if (audioRef?.current) {
      audioRef.current.pause();
    }
  }
  
  function onEnded() {
    setIsPlaying(false);
    setFavicon(FAVICON_ENUM.DEFAULT);
  }

  return (
    <div
      className={styles.player}
      onClick={() => {
        if (isPlaying) {
          pause();
          setFavicon(FAVICON_ENUM.PAUSE);
          setCursor(CURSOR_ENUM.PLAY);
        } else {
          play();
          setCursor(CURSOR_ENUM.PAUSE);
          setFavicon(FAVICON_ENUM.PLAY);
        }
        setIsPlaying(!isPlaying);
      }}
      onMouseEnter={() => {
        if (isPlaying && !isHovered) {
          setCursor(CURSOR_ENUM.PAUSE);
        } else {
          setCursor(CURSOR_ENUM.PLAY);
        }
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        if (isHovered) {
          setIsHovered(false);
          setCursor(CURSOR_ENUM.DEFAULT);
        }
      }}
    >
      <img
        alt="music"
        draggable={false}
        className={styles.player__img}
        src={musicImg}
        style={{ animationPlayState: isPlaying ? "running" : "paused" }}
      />
      <audio ref={audioRef} onEnded={onEnded}>
        <source src={snowAudio} type="audio/mpeg" />
      </audio>
    </div>
  );
}

export default memo(Player);
